<template>
  <nav class="nav-pagina">
    <h1 class="nav-pagina-titulo">{{ titulo }}</h1>
    <b-button v-if="link || boton" class="is-rounded" type="is-primary" size="is-large" icon-left="plus" :tag="boton ? 'button' : 'router-link'" :to="link" @click="$emit('click')">
      {{ texto }}
    </b-button>
  </nav>
</template>
<script>
export default {
  name: "NavComponent",
  props: ["titulo", "link", "texto", "boton"],
}
</script>
